// extracted by mini-css-extract-plugin
export default {"container":"expandableContent_container__BLNiK","title":"expandableContent_title__TAASq","keyValue":"expandableContent_keyValue__t-7jg"};